var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11560_36518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#FFE5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.193359C18.5205 0.193359 23.8066 5.47948 23.8066 12C23.8066 18.5205 18.5205 23.8066 12 23.8066C5.47948 23.8066 0.193359 18.5205 0.193359 12C0.193359 5.47948 5.47948 0.193359 12 0.193359Z",
    stroke: "#FFCDB6",
    strokeWidth: 0.387097
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11560_36518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3494 12.7295L13.6543 14.6553M13.6494 9.34242L10.3494 11.2682M16.3542 8.61177C16.3542 9.41347 15.7043 10.0634 14.9026 10.0634C14.1009 10.0634 13.451 9.41347 13.451 8.61177C13.451 7.81007 14.1009 7.16016 14.9026 7.16016C15.7043 7.16016 16.3542 7.81007 16.3542 8.61177ZM10.5478 11.9989C10.5478 12.8006 9.89785 13.4505 9.09614 13.4505C8.29444 13.4505 7.64453 12.8006 7.64453 11.9989C7.64453 11.1972 8.29444 10.5473 9.09614 10.5473C9.89785 10.5473 10.5478 11.1972 10.5478 11.9989ZM16.3542 15.386C16.3542 16.1877 15.7043 16.8376 14.9026 16.8376C14.1009 16.8376 13.451 16.1877 13.451 15.386C13.451 14.5843 14.1009 13.9344 14.9026 13.9344C15.7043 13.9344 16.3542 14.5843 16.3542 15.386Z",
    stroke: "#BA3B00",
    strokeWidth: 0.903226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11560_36518",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.93548
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.651943 0 0 0 0 0.489183 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11560_36518"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11560_36518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6129,
    height: 11.6129,
    fill: "white",
    transform: "translate(6.19336 6.19336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedIcon);
export default __webpack_public_path__ + "static/media/shared_icon.3f31b2972d1bd8a3dcf5166b8f3c4db8.svg";
export { ForwardRef as ReactComponent };